import React from 'react'
import SchoolUserParentContainerComponent from '../../containers/SchoolUser/SchoolUserParentContainerComponent'
import {
  GetAllClassInSchool,
  GetAllPaymentsPlanInSchool,
  GetCategoriesInSchool,
} from '../../services/api-requests/api-request'
import SchoolMaterialThemeContainer from '../../containers/SchoolMaterialThemeContainer'
import { useSchoolDetails } from '../../hooks/useSchoolDetails'
import SchoolHomepageQuizView from '../../views/School/SchoolHomepageQuizView'
import SchoolUserPageHead from '../../components/SchoolUserPageHead'
import ErrorComponent from '../_error'
import PageLoadingComponent from '../../components/LoadingComponents/PageLoadingComponent'

interface IQuizPageProps {
  school_details: any
  currentUrl: string
  courses: any[]
  categories: any[]
  payment_plans: any[]
  error?: boolean
}

const QuizPage = (props: IQuizPageProps) => {
  return (
    <>
      <SchoolUserPageHead schoolDetails={props.school_details} />
      <SchoolMaterialThemeContainer schoolDetails={props.school_details}>
        <>
          <SchoolUserParentContainerComponent
            school_id={props.school_details._id}
            fb_pixel_id={props.school_details?.fb_pixels_id}
          >
            <div style={{ backgroundColor: '#fff' }}>
              <SchoolHomepageQuizView
                courses={props.courses}
                schoolDetails={props.school_details}
              />
            </div>
          </SchoolUserParentContainerComponent>
        </>
      </SchoolMaterialThemeContainer>
    </>
  )
}

const QuizWrapper: React.FC<any> = () => {
  const { error: schoolError, schoolDetails } = useSchoolDetails()
  const [courses, setCourses] = React.useState<any[]>([])
  const [categories, setCategories] = React.useState<any[]>([])
  const [paymentPlans, setPaymentPlans] = React.useState<any[]>([])
  const [dataLoading, setDataLoading] = React.useState(false)

  React.useEffect(() => {
    if (!schoolDetails?._id) {
      return
    }

    let active = true
    const fetch = async () => {
      setDataLoading(true)
      try {
        const [coursesRes, categoriesRes, paymentRes] = await Promise.all([
          GetAllClassInSchool(schoolDetails._id),
          GetCategoriesInSchool(schoolDetails._id),
          GetAllPaymentsPlanInSchool(schoolDetails._id),
        ])
        if (!active) return
        setCourses(coursesRes?.data?.data || [])
        setCategories(categoriesRes?.data?.data || [])
        setPaymentPlans(paymentRes?.data?.data || [])
      } catch (err) {
        if (active) {
          console.error('Error fetching quiz page data', err)
        }
      } finally {
        if (active) {
          setDataLoading(false)
        }
      }
    }
    fetch().catch(err => {
      console.error('Error fetching quiz page data', err)
      if (active) {
        setDataLoading(false)
      }
    })
    return () => {
      active = false
    }
  }, [schoolDetails?._id])

  if (schoolError) {
    return <ErrorComponent statusCode={404} />
  }

  if (!schoolDetails || dataLoading) {
    return <PageLoadingComponent />
  }
  return (
    <QuizPage
      school_details={schoolDetails}
      currentUrl={
        typeof window !== 'undefined' ? window.location.href : ''
      }
      courses={courses}
      categories={categories}
      payment_plans={paymentPlans}
    />
  )
}

export default QuizWrapper
